/**
 * Application configuration.
 * Centralize constants for easy tuning and environment-specific overrides.
 */

import { BodyType } from "@bennara/shared";

export const CONFIG = {
  /** Model path (relative to public/) */
  models: {
    [BodyType.BODY_TYPE_1]: "/models/body_type_1.glb",
    [BodyType.BODY_TYPE_2]: "/models/body_type_2.glb",
    [BodyType.BODY_TYPE_3]: "/models/body_type_3.glb",
  },
  /** Scene */
  scene: {
    camera: {
      fov: 45,
      near: 0.1,
      far: 1000,
      initialPosition: [0, 0, 4] as [number, number, number],
    },
    modelScale: 2, // model fits within this size
  },

  /** OrbitControls */
  controls: {
    enableDamping: true,
    dampingFactor: 0.05,
    minDistance: 0.5,
    maxDistance: 5,
  },

  /** Point markers (colors come from shared theme) */
  marker: {
    radius: 0.115,
    segments: 16,
    renderOrder: 1,
    /** Scale factor for zoom-based sizing: scale = zoom * sizeScaleFactor (keeps ~constant screen size) */
    sizeScaleFactor: 0.12,
    /**
     * Risk dot drawn on mole spheres (warning / high / critical).
     * Local sprite size; the parent mesh scale keeps it proportional.
     * Sphere diameter is 2 * radius, so this is about a third of the ball.
     */
    riskDot: {
      size: 0.077,
      renderOrder: 2,
      textureSize: 64,
    },
    /** Selection ring drawn around the active point */
    ring: {
      /** Size multiplier relative to marker radius */
      scaleFactor: 1.12,
      renderOrder: 999,
      /** Canvas texture resolution (px) */
      textureSize: 128,
      /** Ring stroke width relative to canvas size */
      strokeRatio: 0.03,
      /** Number of dashes around the ring */
      dashCount: 5,
      /** Fraction of each segment that is a gap (0-1) */
      gapRatio: 0.3,
      /** Pulse animation: opacity oscillates between these bounds */
      pulseMin: 0.6,
      pulseMax: 1,
      /** Pulse speed (full cycles per second) */
      pulseSpeed: 0.6,
    },
  },

  /** Input - pixels moved to distinguish tap from drag */
  input: {
    tapMoveThreshold: 5,
  },
} as const;
